import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {VentilationModel} from '../../dangerous-goods.model';
import {VisitContext} from "../../../visit-context";
import moment from "moment/moment";
import {BerthVisit} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-edit-ventilation',
    templateUrl: './edit-ventilation.component.html',
    styleUrls: ['./edit-ventilation.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditVentilationComponent implements OnInit {
  context=VisitContext;

  @Input() handling: VentilationModel;

  startDateEntered: boolean = false;
  berthVisit: BerthVisit;

  ngOnInit(): void {
    this.berthVisit = VisitContext.berthVisitById(this.handling.berthVisitId);
  }

  blurStartDate() {
    this.startDateEntered = true;
  }

  ventilationBeforeArrivalAtPortOrBerth() {
    return this.context.startsHandlingBeforeArrivalBerthOrPort(this.handling.timestamp, this.berthVisit);
  }

  ventilationBeforeArrivalAtPort() {
    return this.context.startsHandlingBeforeArrivalAtPort(this.handling.timestamp);
  }

  ventilationBeforeArrivalAtBerth() {
    return this.ventilationBeforeArrivalAtPortOrBerth() && !this.ventilationBeforeArrivalAtPort();
  }

  afterEtdBerth() {
    return this.berthVisit.etd && moment(this.handling.timestamp).isAfter(this.berthVisit.etd);
  }
}
